import type { ReactNode } from "react";

type Tone = "ink" | "white" | "accent";

interface EyebrowBadgeProps {
	children: ReactNode;
	icon?: ReactNode;
	tone?: Tone;
	className?: string;
}

const TONE_CLASS: Record<Tone, string> = {
	ink: "border-brand-200/70 bg-brand-50/70 text-brand-700",
	white: "border-white/15 bg-white/5 text-white/80 backdrop-blur",
	accent: "border-brand-400/40 bg-brand-100/60 text-brand-700",
};

export function EyebrowBadge({ children, icon, tone = "ink", className = "" }: EyebrowBadgeProps) {
	return (
		<span
			className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] ${TONE_CLASS[tone]} ${className}`}
		>
			{icon}
			{children}
		</span>
	);
}
